import { createContext, useContext, useMemo } from "react";
import { useQuery } from "react-query";
import DropdownsService from "../../services/dropdowns/dropdowns.service";
import { AuthContext } from "../auth/auth.provider";
import { capitalizeDropdownValue } from "../../utils/dropdowns";

export const DropdownsContext = createContext({
  propertyTypes: [],
  propertySubTypes: [],
  isLoading: false
});

const DropdownsProvider = props => {
  const { children } = props;
  const { user } = useContext(AuthContext);

  const propertyTypesQuery = useQuery(
    ["DropdownsService.getPropertyTypes"],
    () => DropdownsService.getPropertyTypes(),
    { enabled: user?.isLogin }
  );

  const propertySubTypesQuery = useQuery(
    ["DropdownsService.getPropertySubTypes"],
    () => DropdownsService.getPropertySubTypes(),
    { enabled: user?.isLogin }
  );

  const value = useMemo(() => {
    const sortStrings = list =>
      Array.isArray(list) ? [...list].sort((a, b) => a.localeCompare(b)) : [];

    return {
      propertyTypes: sortStrings(propertyTypesQuery.data).map(
        capitalizeDropdownValue
      ),
      propertySubTypes: sortStrings(propertySubTypesQuery.data).map(
        capitalizeDropdownValue
      ),
      isLoading:
        propertyTypesQuery.isLoading || propertySubTypesQuery.isLoading,
      error: propertyTypesQuery.error || propertySubTypesQuery.error
    };
  }, [
    propertyTypesQuery.data,
    propertyTypesQuery.isLoading,
    propertyTypesQuery.error,
    propertySubTypesQuery.data,
    propertySubTypesQuery.isLoading,
    propertySubTypesQuery.error
  ]);

  return (
    <DropdownsContext.Provider value={value}>
      {children}
    </DropdownsContext.Provider>
  );
};

export const useDropdowns = () => useContext(DropdownsContext);

export default DropdownsProvider;
